import apiService from 'frontcore/data/api-service/api-service'
import {
  IShiftsAPIService,
  Shift,
  ShiftAPIResponse,
  ShiftsAPIServiceError,
} from 'frontcore/presentation/shifts/data/types'

const isShiftAPIResponse = (o: unknown): o is ShiftAPIResponse => {
  if (o === null) { return false }
  if (typeof o !== 'object' || !o) { return false }
  return (
    'id' in o &&
    'name' in o &&
    'enabled' in o &&
    'order' in o &&
    'slots' in o &&
    'begin_time' in o &&
    'end_time' in o &&
    'enabled_days' in o &&
    'created' in o &&
    'device_update' in o &&
    'updated' in o
  )
}

const isShiftsAPIResponse = (o: unknown): o is ShiftAPIResponse[] => {
  if (o === null) { return false }
  if (!Array.isArray(o)) { return false }
  return o.every(item => { return isShiftAPIResponse(item) })
}

const REQUEST_URL = 'shifts'

export default class ShiftsAPIClientHTTP implements IShiftsAPIService {

  async fetch (): Promise<Shift[]> {
    try {
      const response = await this.fetchShifts()
      return this.parseItems(response)
    } catch (e) {
      if (e instanceof ShiftsAPIServiceError) { throw e }
      throw new ShiftsAPIServiceError((e as Error).message)
    }
  }

  async fetchShifts (): Promise<ShiftAPIResponse[]> {
    const url = `${REQUEST_URL}/`
    const response = await apiService
      .buildRequest()
      .withSessionToken()
      .get<ShiftAPIResponse>(url)

    const dataResponse = response.data

    if (isShiftsAPIResponse(dataResponse)) { return dataResponse }
    throw new ShiftsAPIServiceError()
  }

  parseItem (response: ShiftAPIResponse): Shift {
    return {
      id: response.id,
      name: response.name,
      enabled: response.enabled,
      order: response.order,
      slots: response.slots,
      beginTime: response.begin_time,
      endTime: response.end_time,
      enabledDays: {
        values: response.enabled_days.values,
      },
      created: response.created,
      deviceUpdate: response.device_update,
      updated: response.updated,
      isDeletable: response.is_deletable,
    }
  }

  parseItems (response: ShiftAPIResponse[]): Shift[] {
    return response.map(this.parseItem)
  }
}
